import * as _ from 'lodash';
import messages from './map-viewer-translations';
import mapViewerFloatingSidemenu from './components/floating-sidemenu/floating-sidemenu.vue';
import mapViewerFooterControls from './components/footer-controls/footer-controls.vue';
import mapViewerShareModal from './components/share-modal/share-modal.vue';
import mapViewerInfoModal from './components/info-modal/info-modal.vue';
import mapViewerPinModal from './components/pin-modal/pin-modal.vue';
import mapViewerPrintModal from './components/print-modal/print-modal.vue';
import mapViewerPrintScaleModal from './components/printscale-modal/printscale-modal.vue';
import mapViewerDownloadModal from './components/downloadlayers-modal/downloadlayers-modal.vue';
import mapViewerPasswordModal from './components/password-modal/password-modal.vue';
import mapViewerDataTableModal from './components/datatable-modal/datatable-modal.vue';
import { AuthService } from '../login/services/authService.js';
import * as $ from 'jquery';

export default {
    name: 'instamapsMapViewer',
    i18n: {
        messages,
    },
    data: function () {
        return {
            backgrounds: [],
            legend: [],
            layers: [],
            layersLeaflet: [],
            searchInput: '',
            allLayersBasicInfo: [],
            showShareModal: false,
            showInfoModal: false,
            showPinModal: false,
            showPrintModal: false,
            showPrintScaleModal: false,
            showPasswordModal: false,
            showDownloadModal: false,
            showDataTableModal: false,
            printModalImageUrl: '',
            printScaleModalUrl: '',
            layersItem: [],
            mapName: '',
            pinModalPins: [],
            instamapsConfig: {},
            attribution: '',
            visor: null,
            isSostenibilitat: false,
            isAtlasMode: false, //DEV: FAKE DATA -> simulates instamapsConfig.isAtlasMode (means show always map info modal in desktop)
            legendOpen: false,  
            visorOptions: null,    
            legendVisible: false,     
        };
    },
    computed: {
        // a computed getter
        author: function () {
            // `this` points to the vm instance
            let autor = "";
            if(_.has(this.instamapsConfig, 'options')) {
                if(_.has(this.instamapsConfig, 'nomEntitat')){
                    autor = this.instamapsConfig.nomEntitat;
                }else{
                    autor = this.instamapsConfig.entitatUid.replace(/@([A-Za-z0-9.-]+\.[A-Za-z]{2,4})$/, '');
                }
                if(_.has(this.instamapsConfig.options, 'alies') && "" !== this.instamapsConfig.options.alies.trim()){
                    autor = this.instamapsConfig.options.alies;
                }
            }
            return autor;
        },
        dataActualitzacio: function () {
            let dataA = "";
            if(_.has(this.instamapsConfig, 'dataActualitzacio')) {
                dataA = this.instamapsConfig.dataActualitzacio;
            }else if(_.has(this.instamapsConfig, 'dataPublicacio')) {
                dataA = this.instamapsConfig.dataPublicacio;
            }else if(_.has(this.instamapsConfig, 'dataConfiguracio')) {
                dataA = this.instamapsConfig.dataConfiguracio;
            }
            return dataA;
        },  
        dataCreacio: function(){
            let dataC = "";
            if(_.has(this.instamapsConfig, 'dataPublicacio')) {
                dataC = this.instamapsConfig.dataPublicacio;
            }
            return dataC;
        }     
    },
    components: {
        mapViewerFloatingSidemenu,
        mapViewerFooterControls,
        mapViewerShareModal,
        mapViewerInfoModal,
        mapViewerPinModal,
        mapViewerPrintModal,
        mapViewerPrintScaleModal,
        mapViewerPasswordModal,
        mapViewerDownloadModal,
        mapViewerDataTableModal,
    },
    props: {
        selectedLang: { type: String },
        hasBreadcrumbs: { type: Boolean },
        isInIframe: { type: Boolean },
    },
    methods: {
        showPasswwordModal: function () {
            this.showPasswordModal = true;
            this.loaded();
        },
        updateLayersLeaflet: function (value) {
            this.layersLeaflet = value.slice();
        },
        loading: function () {
            this.$emit('loading');
        },
        loaded: function () {
            this.$emit('loaded');
        },
        resetMap: function () {

            this.visor.map.remove();
            this.visor.instamapsLayers = null;
            this.visor.popupManager = null;
            this.visor.controls = {};
            this.visor = null;

        },
        createMap: function () {

            // eslint-disable-next-line no-undef 
            return new L.IM_Map('map', {
                zoomAnimation: false,
                typeMap: "topoMapGeo",
                minZoom: 2,
                maxZoom: 19,
                maxBounds: L.latLngBounds(L.latLng(-90, -180), L.latLng(90, 180)),
                zoomControl: true,
                timeDimension: true,
                timeDimensionControl: true,
                timeDimensionControlOptions: {
                    speedSlider: false,
                },
                spinerDiv: 'div_loading',
            }).setView([41.431, 1.8580], 8);
        },
        loadVisor: function () {

            var self = this;
            this.loading();
            // eslint-disable-next-line no-undef 
            this.visorOptions = getParamsVisor();
            if (!this.visorOptions.embed){
                this.visorOptions.embed = self.isInIframe;
            }

            if (this.visor) {
                self.resetMap();
                this.visorOptions.map = self.createMap();			
            }

            if(null === this.visorOptions.businessid || undefined === this.visorOptions.businessid || '' === this.visorOptions.businessid){
                this.visorOptions.businessid = 'geocatweb';
            }

            var appmodul = this.visorOptions.appmodul;

            // eslint-disable-next-line no-undef
            var visor = Visor(this.visorOptions);
            this.visor = visor;

            if(this.visorOptions.businessid === 'geocatweb'){
                visor.draw();
                self.loaded();
            }else{
                visor.loadMapConfig(function (mapConfig) {
                    self.instamapsConfig = mapConfig;
                    self.mapName = self.instamapsConfig.nomAplicacio;
                    
                    //Comprovem si el mapa està publicat
                    if (self.instamapsConfig === undefined || (self.instamapsConfig !== undefined && self.instamapsConfig.options === undefined) 
                    || (self.instamapsConfig !== undefined && self.instamapsConfig.dataConfiguracio === undefined) || 
                    (self.instamapsConfig !== undefined && self.instamapsConfig.dataConfiguracio === self.instamapsConfig.dataPublicacio) ) {
                        alert("No pots entrar al visor perquè el mapa no ha estat publicat. Seràs redirigit a l'edició del mapa");
                        //si estas loginat i userid ets tu
                        if (AuthService.getUid() === self.instamapsConfig.entitatUid) {
                            var url = "/mapa.html?businessid="+self.instamapsConfig.businessId;
                            window.location.href = url;
                        }
                        else {
                            window.location.href = "/";
                        }
                    }
                    else {
                        self.$root.$emit("logoChanged", self.instamapsConfig.logo);
                        if(_.has(self.instamapsConfig, 'options')) {
                            self.$root.$emit("URLChanged", self.instamapsConfig.options.urlLogo);                        
                        }                      
                        self.$root.$emit("mapNameChanged", self.instamapsConfig.nomAplicacio);
                        if(_.has(self.instamapsConfig, 'options')) {
                            self.$root.$emit("contactChanged", self.instamapsConfig.options.contacte);                      
                        }
                        
                        self.getLayersInfo(self);
                        self.getLegendInfo(self);

                        self.visor.draw();
                        self.visor.loadOptionsToCheck(self, self.instamapsConfig);
						
                        // eslint-disable-next-line no-undef 
                        self.backgrounds = JSON.parse(getFonsVisor(mapConfig.tipusAplicacioId));
                        // eslint-disable-next-line no-undef 
                        addModul3D(mapConfig);

                        if(appmodul){
                            self.visor.addAppModul(appmodul);
                            if(appmodul === 'sostenibilitat'){
                                self.isSostenibilitat = true;
                            }
                        }
                                              
                        //Raises a leaflet event to get the original layers state and update checkboxes
                        // eslint-disable-next-line no-undef 
                        toggleCapa();
                    }
                });
            }  
        },
        getAttribution: function () {
            // eslint-disable-next-line no-undef
            var str = InstamapsUtils.Mapa.getAtributionControlHtml(map);
            return str;
        },
        getLayerDownload: function (id, downloadableData) {
            var isDownloable = false;
            if(downloadableData && downloadableData[id]){
                isDownloable = downloadableData[id][0].chck;
            }
            return isDownloable;
        },
        getLayersInfo: function (obj) {
            var self = this;
            var originLayers = obj.instamapsConfig.servidorsWMS.filter(x => x.capesGroup !== '' && x.capesGroup!=='null');
            var subLayers = obj.instamapsConfig.servidorsWMS.filter(x => x.capesGroup === '' || x.capesGroup==='null');
            var downloadableData = obj.instamapsConfig.options.downloadable; 
            originLayers = _(originLayers)
            .sortBy(o => {
                return parseInt(o.capesOrdre);
            });      
            var layerGroups = _(originLayers)
                .sortBy(o => {
                    return parseInt(o.capesOrdre);
                })
                .map(x => {
                    var gr = {};
                    if (x.capesGroup) {

                        gr = JSON.parse(x.capesGroup);
                        delete gr['z_order'];

                    }

                    gr['layers'] = [];
                    return gr;
                })
                .uniqBy('id')
                .value();

            var newOriginLayers = [];
            originLayers.forEach(element => {
                var elementSubLayers = subLayers.filter(x => element.businessId === JSON.parse(x.options).origen);

                if (elementSubLayers) {
                    var tempElementSubLayer = [];
                    elementSubLayers.forEach(function (elementSubLayer) {
                        tempElementSubLayer.push({
                            businessId: elementSubLayer.businessId,
                            serverName: elementSubLayer.serverName,
                            options: elementSubLayer.options,
                            serverType: elementSubLayer.serverType,
                        });
                    }, this);
                    elementSubLayers = tempElementSubLayer;
                    obj.allLayersBasicInfo = obj.allLayersBasicInfo.concat(tempElementSubLayer);
                } else {
                    elementSubLayers = [];
                }

                var downloadble = self.getLayerDownload(element.businessId, downloadableData);

                var newOriginLayer = {
                    businessId: element.businessId,
                    capesOrdre: element.capesOrdre,
                    serverName: element.serverName,
                    visibilitat: element.visibilitat,
                    options: element.options,
                    sublayers: elementSubLayers,
                    download: downloadble,
                    serverType: element.serverType,
                };
                newOriginLayers.push(newOriginLayer);
                obj.allLayersBasicInfo.push({
                    businessId: element.businessId,
                    serverName: element.serverName,
                    options: element.options,
                    serverType: element.serverType,
                });

                var layerGroupId = 0;
                if (element.capesGroup) {

                    layerGroupId = JSON.parse(element.capesGroup).id;

                }

                var group = layerGroups.find(x => x.id === layerGroupId);
                if (!group) {
                    group = layerGroups[0];
                }
                
                group.layers.push(newOriginLayer);
            }, this);

            obj.layers = layerGroups;
           

        },
        getLegendInfo: function (obj) {
            var legendObject = {};
            if (obj.instamapsConfig.legend) {

                legendObject = JSON.parse(obj.instamapsConfig.legend);

            }

            var legendItems = [];
            Object.keys(legendObject).forEach(function (key) {
                var visibleLegendObjects = legendObject[key].filter(x => x.chck === true);
                var legendLayer = obj.allLayersBasicInfo.find(x => x.businessId === key);
                if (legendLayer && visibleLegendObjects && visibleLegendObjects.length > 0) {
                    legendItems.push({
                        name: legendLayer.serverName,
                        items: visibleLegendObjects,
                        layerBusinessId: key,
                        options: legendLayer.options,
                        serverType: legendLayer.serverType,
                    });
                }
            }, this);
            obj.legend = legendItems;
        },
        mapInfo: function () {
            this.updateAttribution();
            this.showInfoModal = true;
        },
        updateAttribution: function () {
            this.attribution = this.getAttribution();
        },
        likeMap: function () {
            // eslint-disable-next-line no-undef 
            like(this.instamapsConfig);
        },
        locate: function () {
            // eslint-disable-next-line no-undef 
            locateUser();
        },
        deleteLocate: function(){
            deleteLocateMarker();
        },
        home: function () {
            // eslint-disable-next-line no-undef 
            goHome(this.instamapsConfig);
        },
        share: function () {            
            this.showShareModal = true;
        },
        launch: function (){
            window.open(window.location.href, '_blank');
        },
        closeShareModal: function () {
            this.showShareModal = false;
        },
        closeInfoModal: function () {
            this.showInfoModal = false;
        },
        mapPin: function (data) {
            if (data) { 
                this.pinModalPins = data; 
            }
            try{
                var notWMS = data.every((elem) => (elem.htmlContent===undefined || (elem.htmlContent!==undefined && elem.htmlContent.indexOf("wms-content") === -1)));
                if(!this.isSostenibilitat || (this.isSostenibilitat && !notWMS)) {
                    this.showPinModal = true;
                }
            }catch(e){
                notWMS=true;
                if(!this.isSostenibilitat || (this.isSostenibilitat && !notWMS)) {
                    this.showPinModal = true;
                }
            }
            
            
        },
        closePinModal: function () {
            this.showPinModal = false;
        },
        printModal: function (ev) {
            this.printModalImageUrl = ev.imageUrl;
            this.showPrintModal = true;
        },
        closePrintModal: function () {
            this.showPrintModal = false;
        },
        printScaleModal: function (ev) {
            this.printScaleModalUrl = ev.url;
            this.showPrintScaleModal = true;
        },
        closePrintScaleModal: function () {
            this.showPrintScaleModal = false;
        },
        downloadModal: function () {     
            var self=this;
            self.layersItem = [].concat(self.layers);
            self.layersItem = self.layersItem.map((layer) => {
                layer.layers = layer.layers.filter(x => x.download===true);
                return layer;
            });
            if ((self.layersItem.layers !== undefined && self.layersItem.layers.length === 0) || 
                (self.layersItem[0].layers !== undefined && this.layersItem[0].layers.length === 0)){
                $('#modal_download_layer #desc')[0].innerHTML = 'No hi ha capes per descarregar';
            }               
            this.showDownloadModal = true;
        },
        closeDownloadModal: function () {
            this.showDownloadModal = false;
        },
        loadMapConfig: function (config){
            var self = this;
            self.showPasswwordModal = false;
            self.visor._beforeLoadConfig(config, function (_mapConfig){
                self.instamapsConfig = _mapConfig;
                
                self.$root.$emit("logoChanged", self.instamapsConfig.logo);
                if(_.has(self.instamapsConfig, 'options')) {
                    self.$root.$emit("URLChanged", self.instamapsConfig.options.urlLogo);                        
                }                      
                self.$root.$emit("mapNameChanged", self.instamapsConfig.nomAplicacio);
                if(_.has(self.instamapsConfig, 'options')) {
                    self.$root.$emit("contactChanged", self.instamapsConfig.options.contacte);                      
                }


                self.getLayersInfo(self);
                self.getLegendInfo(self);
    
                self.visor._drawVisor();
                self.visor.loadOptionsToCheck(self, self.instamapsConfig);
                // eslint-disable-next-line no-undef 
                self.backgrounds = JSON.parse(getFonsVisor(self.instamapsConfig.tipusAplicacioId));
                // eslint-disable-next-line no-undef 
                addModul3D(_mapConfig);
				           
                //Raises a leaflet event to get the original layers state and update checkboxes
                // eslint-disable-next-line no-undef 
                toggleCapa();
            });
        },          
        closeDataTableModal: function (){
            this.showDataTableModal = false;
        },
        loadUrlFile: function (){
            var self=this;
            if(this.visorOptions.urlFile && this.visorOptions.tipusFile === "json") {            
                this.visor._loadUrlFile();
                if(this.visorOptions.text) {
                    this.visor._addURLMarker();
                }
            }
            self.loaded();
        },
        getHtmlLlegenda: function (){
            var self = this;
            var html='<ul class="list expandable-content" id="llegenda_compacta" style="display:block">';
            for (var i in self.legend){
                var element = self.legend[i];
                html += '<li>';
                html += '<div class="subitem">';
                html += '<div class="subitem-header" ><span>';
                html += element.name ;
                html += '</span></div>';
                html += '<ul class="subitem-list expandable-content ">';
                for (var j in element.items){
                    var subelement = element.items[j];
                    var name = subelement.name;
                    (name.length > 30)?name=name.substring(0,30)+"...":name;
                    html += '<li>';
                    html += '<div class="legend-symbol truncate">';  
                    html+='<div class="legend-symbol-html">'+subelement.symbol+'</div>';
                    html+='<span class="legend-symbol-name">'+name+'</span>';                                      
                    html += '</div><div class="clear-fix"></div></li>';
                }               
                html += '</ul></div></li>';
            }
            html+='</ul>';
            return html;          
        },
    },
    mounted: function () {
        this.loadVisor();
        setTimeout(() => { // setTimeout to put this into event queue            
            this.loadUrlFile();          
        }, 900);
    },
    
};




// WEBPACK FOOTER //
// ./src/map-viewer/map-viewer.js